import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

export const SET_LISTA_EXAME = "setListExame"
export const SET_MESSAGE_ALERT = 'setMensagem'

const actions = {

    //#region  exame
    async create_exame(context, value) {
        let message = await ApiService.post('exame', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_exame(context, value) {
        const id = value.id
        delete(value.id)
        let message = await ApiService.put('exame/atualizar/' + id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async bloquear_exame(context, value) {
        let message = await ApiService.get('exame/bloquear/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async desbloquear_exame(context, value) {
        let message = await ApiService.get('exame/desbloquear/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async delete_exame(context, value) {
        let message = await ApiService.get('exame/deletar/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async listar_exames(context, params) {
        await ApiService.get('exame')
            .then(response => context.commit(SET_LISTA_EXAME, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async pesquisar_exames(context, params) {
        await ApiService.post('exame/search',params)
            .then(response => context.commit(SET_LISTA_EXAME, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    async gerar_excel(context, data) {
        ApiService.post("exame/gerar_excel", data, {
            responseType: 'blob'
        }).then(response => {
            let fileUrl = window.URL.createObjectURL(response.data);
            let fileLink = document.createElement('a');

            fileLink.href = fileUrl;
            fileLink.setAttribute('download', 'examenes_registrados.xls');
            document.body.appendChild(fileLink)

            fileLink.click();
        }).catch((error) => context.commit(SET_MESSAGE_ALERT, {
            tipo: 'error', message: error.response.data
        }))
    },

    //#endregion




};

const getters = {};

const mutations = {
    [SET_LISTA_EXAME](state, value) {
        state.lista_exames = value
    },


    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {
            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
};

const state = {
    lista_exames: [],
    mensagem_alert: "",


};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};